module.exports = "\n<div class=\"comp-loading-indicator\" :class=\"[visible ? 'comp-loading-indicator-visible' : '']\"></div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/loading_indicator/index.pug
// module id = 664
// module chunks = 4